import { FaBell } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

function isIdFormat(segment: string) {
  const uuidPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
  return uuidPattern.test(segment) || /^\d/.test(segment);
}

function getPageInfo(path: string) {
  const segments = path.split("/").filter(Boolean);

  if (segments.length === 0 || ((segments[0] === "blood_bank" || segments[0] === "hospital") && segments.length === 1)) {
    return { breadcrumbItems: [{ label: "Pages", path: "#" }, { label: "Home", path: "/" }], title: "Home" };
  }

  const breadcrumbItems = [{ label: "Pages", path: "#" }];
  let currentTitle = "Home";
  let currentPath = "";

  for (const segment of segments) {
    currentPath += `/${segment}`;
    if (segment === "blood_bank" || isIdFormat(segment)) continue;
    const formattedSegment = segment.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    breadcrumbItems.push({ label: formattedSegment, path: currentPath });
    currentTitle = formattedSegment;
  }

  return { breadcrumbItems, title: currentTitle };
}

export default function Header() {
  const { pathname } = useLocation();
  const { profile } = useAuth();
  const { breadcrumbItems, title } = getPageInfo(pathname);

  return (
    <div className="bg-[#f8f8f8] p-3">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-sm text-gray-500">
            {breadcrumbItems.map((item, index) => (
              <span key={index}>
                {index === breadcrumbItems.length - 1 ? (
                  <span className="text-blue-600">{item.label}</span>
                ) : (
                  <>
                    <Link to={item.path} className="hover:text-blue-600 cursor-pointer transition-colors duration-200">
                      {item.label}
                    </Link>
                    <span className="mx-1">/</span>
                  </>
                )}
              </span>
            ))}
          </div>
          <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
        </div>

        <div className="flex items-center space-x-4">
          <div className="relative">
            <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors duration-200 relative">
              <FaBell className="w-5 h-5" />
            </button>
          </div>
          <div className="flex items-center space-x-3">
            <div className="hidden sm:block text-right">
              <div className="text-sm font-medium text-gray-800">{profile?.given_name}</div>
              <div className="text-xs text-gray-500">{profile?.family_name}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
